import { Component, OnInit } from '@angular/core';
import { OrderServiceService } from '../order-service/order-service.service';
import {PackageServiceService} from '../../package/service/package-service.service';
import {PatientService} from '../../patient/service/patient.service';
import {Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-order-view',
  templateUrl: './order-view.component.html',
  styleUrls: ['./order-view.component.css']
})
export class OrderViewComponent implements OnInit {

  itemsPerPage = 10;
  currentPage = 1;
  ORDER_PROVISION: boolean;
  currentUser: any;
  numberOfOrders: any;
  currentUserPermission: any = [];
  orderStatusList: any = [
        { id: '1', value: 'COMPLETED' },
        { id: '2', value: 'NEW' },
        { id: '3', value: 'IN_PROGRESS' },
        { id: '4', value: 'CANCELLED' },
        { id: '5', value: 'COMPLETED_DELIVERED' }
  ];
  regexExp= '';
  status= '';

  constructor(private orderService: OrderServiceService, private modalService: NgbModal, private router: Router, private toastr: ToastrService) { }

  public orderList: any = [];
  public loading = true;
  public currentOrder: any;
  public closeResult: string;
  ngOnInit() {

    this.currentUser = JSON.parse(localStorage.getItem('user'));
    this.currentUserPermission = this.currentUser.permissions[localStorage.getItem('clientId')];
   /* for (let i = 0; i < this.currentUserPermission.length; i++) {
      if (this.currentUserPermission[i] === 'ORDER_PROVISION' ) {
        break;
      } else if (this.currentUserPermission[i].indexOf('NURSE') >= 0) {
        console.log('Enable NURSE Permission');
        break;
      }
    }*/
    this.getAllOrders(this.status, this.regexExp);
  }

  public getAllOrders(status, regex) {
        this.loading = true;
        this.orderService.getAllOrders(this.currentPage - 1, status, this.itemsPerPage, regex).subscribe(data => {
        const response: any = data.json();
        this.orderList = response.orders;
        this.numberOfOrders = response.numberOfOrders;
        console.log(response.packages);

        this.loading = false;
        // TODO - Uncomment below code when useing actual API
        // const response: any = data;
        // if (response.status === 200) {
        //   this.userList = response.result;
        // } else {
        //   this.toastr.error('', 'Please try again');
        // }
        }, (error) => {
        this.loading = false;
        // this.toastr.error('', 'Please try again');
      });
  }
  public cancelOrderNav(order, orderId) {
        this.loading = true;
        let orderCommentRequest : any;

        this.orderService.cancelOrder(orderId, {comment:"Cancelled by user"}).subscribe(data => {
            order.status = 'CANCELLED';
            this.loading = false;
            this.toastr.success('', 'Order canceled successfully!');
            this.getAllOrders(this.status, this.regexExp);
        }, (error) => {
            this.loading = false;
            this.toastr.error('', 'Failed to cancel order, Please try again');
      });
  }

  pageChanged(event) {
    this.currentPage = event;
    this.getAllOrders(this.status, this.regexExp);
    console.log(event);
  }

  onChangeStatusFilter(orderStatus) {
        console.log(orderStatus);
        this.status = orderStatus;
        this.getAllOrders(this.status, this.regexExp);
    }


  provisionOrderNav(orderId, clientNumber, orderNumber) {
    this.router.navigate( [ '/elasticcare/provision/order' , {orderIdParam: orderId, clientNumberParam: clientNumber, orderNumberParam: orderNumber}]);
    //this.router.navigate( [ '/elasticcare/provision/order' ], { fragment: orderId } );
  }

 public editOrderNav(orderId) {
    this.router.navigate( [ '/elasticcare/add/order' , {orderIdParam: orderId}]);
    //this.router.navigate( [ '/elasticcare/provision/order' ], { fragment: orderId } );
  }

  search() {
    console.log('' + this.regexExp);
    this.getAllOrders(this.status, this.regexExp);
  }

  showOrderHistory(orderHistoryPopup, order){
        this.currentOrder = order;
        this.modalService.open(orderHistoryPopup, {size: 'lg', ariaLabelledBy: 'modal-basic-title2'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
  }

  showOrderDetails(content, order){
        this.currentOrder = order;
        this.modalService.open(content, {size: 'lg', ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
  }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return  `with: ${reason}`;
        }
    }

}
